import { render } from "./HeaderComponent.vue?vue&type=template&id=23ddc31c"
import script from "./HeaderComponent.vue?vue&type=script&lang=js"
export * from "./HeaderComponent.vue?vue&type=script&lang=js"

import "./HeaderComponent.vue?vue&type=style&index=0&id=23ddc31c&lang=css"
import "./HeaderComponent.vue?vue&type=style&index=1&id=23ddc31c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__